import { getCountryCodeUserUtil } from 'models/daos/user/utils/get-country'
import { COUNTRY_CURRENCY } from 'modules/country/constants/currency'

/**
 * Gets the current user's currency based on their location.
 * @param  {User} user
 * @returns {string}
 */

function getCurrencyUserUtil (user) {
  const country = getCountryCodeUserUtil(user)
  return COUNTRY_CURRENCY[country] || COUNTRY_CURRENCY.US
}

export {
  getCurrencyUserUtil
}
